import { render } from "./ResumenObsResp.vue?vue&type=template&id=3656c607&scoped=true"
import script from "./ResumenObsResp.vue?vue&type=script&lang=js"
export * from "./ResumenObsResp.vue?vue&type=script&lang=js"

import "./ResumenObsResp.vue?vue&type=style&index=0&id=3656c607&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3656c607"]])

export default __exports__